var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVisibilityOffLight = function SvgIconVisibilityOffLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_visibility_off_light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.586 12.987-9.38-9.473.521-.516 9.38 9.473-.52.516Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.062 8.642a1.125 1.125 0 0 1-1.029.673A1.135 1.135 0 0 1 6.9 8.183c0-.464.282-.858.685-1.033l1.477 1.492Zm-2.495-.46v.003-.003Z",
    stroke: "#fff",
    strokeWidth: 0.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.033 9.48c-.716 0-1.3-.583-1.3-1.3 0-.573.377-1.056.894-1.23l-.557-.56a2.033 2.033 0 1 0 2.743 2.77l-.556-.56a1.3 1.3 0 0 1-1.224.88ZM10.067 8.182c0-1.12-.914-2.034-2.034-2.034-.056 0-.11.004-.163.007l2.187 2.21c.006-.06.01-.12.01-.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.033 5.381c2.89 0 4.02 2.137 4.297 2.81-.113.27-.42.884-.997 1.464l.517.52a5.624 5.624 0 0 0 1.153-1.7c.08-.19.08-.4 0-.594-.323-.76-1.633-3.236-4.973-3.236-.517 0-1.01.063-1.477.183l.614.62c.276-.047.566-.07.863-.07l.003.003ZM10.637 10.237c-.74.493-1.617.743-2.604.743-2.89 0-4.02-2.136-4.296-2.79v-.02c.163-.383.803-1.68 2.246-2.36.11-.053.227-.1.35-.146.007 0 .01-.004.017-.007l-.557-.563-.12.05C4.04 5.914 3.3 7.317 3.06 7.884c-.08.19-.08.4 0 .59.323.76 1.633 3.236 4.973 3.236 1.134 0 2.147-.29 3.01-.866.09-.06.174-.124.257-.187l-.523-.527-.14.104v.003Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_visibility_off_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3)",
    d: "M0 0h10.107v9.99H0z"
  })))));
};
export default SvgIconVisibilityOffLight;